<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto py-6">
      <div v-if="loader" class="flex flex-col justify-center items-center py-20">
        <svg class="animate-spin h-10 w-10 text-orange-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Carregando relatório de motoristas...</span>
      </div>

      <div v-else-if="showMessage" class="bg-white rounded-xl shadow-sm border border-slate-200 p-12 flex flex-col items-center justify-center text-center">
        <v-icon color="orange" size="48" class="mb-4">mdi-alert-circle-outline</v-icon>
        <p class="font-bold text-slate-700 text-lg mb-2">Ops! Algo deu errado.</p>
        <p class="text-slate-500 max-w-md mb-4">{{ message }}</p>
        <button class="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-lg transition-colors text-xs uppercase tracking-wider" @click="loadReport">
          Tentar Novamente
        </button>
      </div>

      <MotoristasReportModel
        v-else
        :data="dataReport"
        :prefecture="prefecture"
        :show-prefecture-column="isAllPrefectures"
      />
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import MotoristasReportModel from "./motoristasReportModel.vue";

export default {
  name: "MotoristasReport",
  components: {
    MotoristasReportModel,
  },
  mixins: [Helpers],
  props: {
    prefecture_id: {
      default: null,
    },
  },
  data: () => ({
    dataReport: [],
    prefecture: null,
    showMessage: false,
    loader: false,
    message: "",
  }),
  computed: {
    isAllPrefectures() {
      return !this.prefecture_id || this.prefecture_id === "all" || this.prefecture_id === "null";
    },
  },
  created() {
    this.loadReport();
  },
  methods: {
    loadReport() {
      this.message = "";
      this.showMessage = false;
      this.loader = true;
      this.$store.dispatch("setLoader", true);

      if (this.isAllPrefectures) {
        // Se for todas as prefeituras
        this.prefecture = {
          prefecture_social_name: "TODAS AS PREFEITURAS / CLIENTES",
          prefecture_logo: null,
        };

        this.$http
          .get("/drivers")
          .then((r) => {
            this.dataReport = r.data || [];
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          })
          .catch((e) => {
            this.loader = false;
            this.showMessage = true;
            this.message = e.message || "Erro ao carregar dados de motoristas.";
            this.$store.dispatch("setLoader", false);
          });
      } else {
        // Se for prefeitura específica
        const prefId = this.prefecture_id;
        const reqDrivers = this.$http.get(`/drivers/prefectures/${prefId}`);
        const reqPref = this.$http.get(`/prefectures/${prefId}`);

        Promise.all([reqDrivers, reqPref])
          .then(([rDrivers, rPref]) => {
            this.dataReport = rDrivers.data || [];
            this.prefecture = (rPref.data && rPref.data[0]) ? rPref.data[0] : {
              prefecture_social_name: "PREFEITURA",
              prefecture_logo: null,
            };
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          })
          .catch((e) => {
            this.loader = false;
            this.showMessage = true;
            this.message = e.message || "Erro ao carregar relatório da prefeitura.";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
